import { createScopedRouterHelpers } from "@circle-react/utils/router/createScopedRouterHelpers";

import type { UpgradePlanRouter } from "./router";

export const { useScopedNavigate: useUpgradePlanNavigate } =
  createScopedRouterHelpers<UpgradePlanRouter>();
